// Shows which fields stopped an intake form from being sent: each one gets a
// red border and a short message under it, and the page scrolls to the first.
// Used by the client link (IntakeFormFill) and the admin preview
// (IntakeFormPreview). Plain DOM helpers, no React.

const MESSAGE_CLASS = 'intake-field-problem';

// The smallest element holding every input of the field: Formeo's label and
// input wrapper, or the wrapper around a radio or checkbox group.
const fieldWrapper = (elements) => {
    let node = elements[0]?.parentElement;
    while (node && !elements.every((el) => node.contains(el))) {
        node = node.parentElement;
    }
    return node;
};

const clearWrapper = (wrapper) => {
    delete wrapper.dataset.fieldProblem;
    wrapper.querySelector(`:scope > .${MESSAGE_CLASS}`)?.remove();
};

export const clearFieldProblems = (container) => {
    container?.querySelectorAll('[data-field-problem]').forEach(clearWrapper);
};

// Editing a marked field clears its mark. The next submit checks it again.
const clearOnEdit = (event) => {
    const wrapper = event.target.closest?.('[data-field-problem]');
    if (wrapper) clearWrapper(wrapper);
};

const byPageOrder = (a, b) =>
    a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;

/**
 * Mark each problem field and scroll to the first one. `problems` is a list of
 * { elements, message } from buildIntakeSubmission. Marks from an earlier
 * submit are cleared first, so an empty list just clears them.
 */
export const showFieldProblems = (container, problems = []) => {
    if (!container) return;
    clearFieldProblems(container);

    if (!container.dataset.fieldProblemListener) {
        container.dataset.fieldProblemListener = 'true';
        container.addEventListener('input', clearOnEdit);
        container.addEventListener('change', clearOnEdit);
    }

    const wrappers = [];
    problems.forEach(({ elements, message }) => {
        const wrapper = fieldWrapper(elements);
        if (!wrapper || wrapper.dataset.fieldProblem) return;

        wrapper.dataset.fieldProblem = 'true';
        const note = document.createElement('p');
        note.className = `${MESSAGE_CLASS} text-2sm text-danger mt-1`;
        note.textContent = message;
        wrapper.appendChild(note);
        wrappers.push(wrapper);
    });

    const first = wrappers.sort(byPageOrder)[0];
    if (!first) return;

    first.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
    first
        .querySelector('input:not([aria-hidden="true"]), select:not([aria-hidden="true"]), textarea')
        ?.focus({ preventScroll: true });
};
